import request from './request'

// 维保单位登录 (调用管理端同一接口，由后端根据角色过滤)
export function login(username, password) {
  return request({ url: '/admin/auth/login', method: 'post', data: { username, password } })
}

// 发送短信验证码
export function sendSms(phone) {
  return request({ url: '/admin/auth/send-sms', method: 'post', data: { phone } })
}

// 手机号验证码登录
export function mobileLogin(phone, code) {
  return request({ url: '/admin/auth/mobile-login', method: 'post', data: { phone, code } })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({ url: '/admin/auth/userInfo', method: 'get' })
}

// 修改个人信息
export function updateProfile(data) {
  return request({ url: '/maintenance/user/profile', method: 'put', data })
}

// 修改密码
export function updatePassword(data) {
  return request({ url: '/maintenance/user/profile/password', method: 'put', data })
}

// 单位注册（维保单位/使用单位）
export function register(data) {
  return request({ url: '/admin/system/user/register', method: 'post', data })
}
